import { render, staticRenderFns } from "./new Committees.vue?vue&type=template&id=3d35429b"
import script from "./new Committees.vue?vue&type=script&lang=js"
export * from "./new Committees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports